import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styles } from './styles';

import FilterIcon from './FilterIcon';
import { useTheme } from 'styled-components';

const ZTextField = ({
  placeholder = 'Search',
  style,
  handleChange,
  withFilter = false,
  value,
  variant = 'pill'
}) => {
  const theme = useTheme();
  const isSquare = variant === 'square';
  return (
    <>
      <TextField
        style={style}
        variant="outlined"
        sx={[styles.inputRoot, isSquare && styles.inputRootSquare]}
        onChange={handleChange}
        value={value}
        InputProps={{
          type: 'search',
          style: {
            borderRadius: '4px',
            padding: '5px 4px',
            backgroundColor: theme.background.secondary,
            color: isSquare ? theme.text.primary : theme.text.placeholder,
            fontSize: '14px',
            boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.04)'
          },
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: '#a2a2a2' }} />
            </InputAdornment>
          )
        }}
        placeholder={placeholder}
      />
      {withFilter ? (
        <div style={styles.filterIconContainer}>
          <FilterIcon />
        </div>
      ) : null}
    </>
  );
};

export default ZTextField;
